<template>
  <template v-if="MenuPrivateInstance">
    <TSeparator
      v-if="showSeparator"
      classes="my-4"
      color-classes="border-gray-300"
    />
    <nav>
      <template v-for="(item, index) in MenuPrivateInstance" :key="index">
        <TMenuItem
          :href="item.href"
          :icon="item.icon"
          :unread="item.unread"
          :target="item.target"
          :selected="item.selected"
          :aria-label="t(item.name)"
        >
          {{ t(item.name) }}
        </TMenuItem>
      </template>
    </nav>
  </template>
</template>

<script setup lang="ts">
import { useMenuPrivate } from '../composables/useMenuPrivate'

const { MenuPrivateInstance } = useMenuPrivate()

defineProps({
  showSeparator: {
    type: Boolean,
    default: false,
  },
})
</script>
